import { render, staticRenderFns } from "./ManualTypes.vue?vue&type=template&id=6f876700&scoped=true"
import script from "./ManualTypes.vue?vue&type=script&lang=js"
export * from "./ManualTypes.vue?vue&type=script&lang=js"
import style0 from "./ManualTypes.vue?vue&type=style&index=0&id=6f876700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f876700",
  null
  
)

export default component.exports